<template>
    <div class="generalframezz">
        <div class="generalcontent" :style="{width:mywidth+'px',height:myheight+'px'}">
            <div class="imgbox">
                <img @click="parentHandleclick()" class="timgclose" src="./close.png" alt='版权登记'/>
            </div>
            <div class="search-group">
                <input v-model="phone" type="text" placeholder="输入手机号领取免费会员" />
                <input @click="goway" id="addButton" type="button" value="立即领取" />
            </div>
            <p class="red-p" v-show="showCode">请输入正确的手机号</p>
        </div>
    </div>
</template>

<script>
import { _getGiftVip } from "@/api/activity.js";
    export default {
        /*******************写这个会导致首页的title不正确*******************/
        // metaInfo: {
        //     title: '证书核验|版权服务专家|版权家',
        //     meta: [{                 // set meta
        //         name: 'keyWords',
        //         content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
        //     },{
        //         name: 'Description',
        //         content: '证书核验,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
        //     }]
        // },
        /***************************************************************/
        name:'verifyCode',
        props:{
            mywidth:{
                type:String,
                default:'577'
            },
            myheight:{
                type:String,
                default:'320'
            },
            flag:{
               type:String,
               default:"" 
            }
        },
        data(){
            return{
              phone:'',
              showCode:false
            }
        },
        methods: {
            parentHandleclick() {
                this.$emit('fatherModal');
            },
            goway(){
                if (this.phone && !this.showCode) {
                    this.showCode = false;
                    _getGiftVip({
                        phone:this.phone,
                        appKey:''
                    }).then(res=>{
                        if(res.code==200){
                            toast("领取成功，会员服务实时生效。")                           
                        }else{
                            toast(res.message)
                        }
                    })
                }else{
                    this.showCode = this.showCode || !this.phone
                }   
               
            }
        },  
        watch:{
            'phone': {
                handler: function () {
                    let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;        
                    if (myreg.test(this.phone)) {
                        this.showCode = false
                    } else {
                        this.showCode = true
                    }
                }
            },
        }          
    }
</script>

<style scoped lang="less">
.generalframezz{
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    text-align: center;
    margin: auto;
    z-index: 558;
    .generalcontent{
        background:url(./bg.png) no-repeat;
        background-size: cover;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;   
        .imgbox{
            text-align: right;
            overflow: hidden;
            .timgclose{
                width:20px;
                height:20px;
                margin:21px 21px 0 0;
                cursor: pointer;
            }
        }
        .search-group{
            width:382px;
            height:40px;
            background:rgba(255,255,255,1);
            border-radius:20px;
            border:1px solid rgba(230,230,228,1);
            display:flex;
            justify-content: center;
            position: relative;
            z-index: 200;
            margin-left: 26px;
            margin-top:177px;
            input{
                border:0;
                outline: none;
            }
            input:first-child{
                width:236px;
                margin-left:19px;
            }
            input:last-child{
                width:126px;
                height:38px;
                background:rgba(33,0,62,1);
                border-radius:0px 20px 20px 0px;
                font-size:16px;
                font-weight:400;
                color:#FFB300;
                line-height:38px;
                cursor:pointer;
            }
            input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
                color:rgba(40,40,40,1);
                font-size:12px;
            }
            input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
               color:rgba(40,40,40,1);
                font-size:12px;
            }
            input::-moz-placeholder { /* Mozilla Firefox 19+ */
                color:rgba(40,40,40,1);
                font-size:12px;
            }
            input:-ms-input-placeholder { /* Internet Explorer 10-11 */
                color:rgba(40,40,40,1);
                font-size:12px;
            }
        }   
    }
   .red-p {
        color: #f00;
        text-align: left;
        margin-left:45px;
    } 
}
</style>